import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import WhyAIAutomation from '../../Components/Automation/WhyAIAutomation'
import IndustriesWeServe from '../../Components/Automation/IndustriesWeServe'
import { ArrowRight, CheckCircle, CheckCircle2 } from 'lucide-react'
import Banner from '../../Components/Banner'
import { Helmet } from 'react-helmet-async';
import WhyChooseGCCSection from './ai/WhyChooseGCCSection'
import ContactSection from '../../Components/home/ContactSection'

const featuresData = [
    {
        id: 1,
        title: "GCC Setup & Strategy",
        description:
            "We help you choose the right location, build a practical operating model, plan your team, and stay compliant keeping your business simple, strong, and ready to grow.",
        image: "/assets/what/img3.png",
    },
    {
        id: 2,
        title: "Talent Acquisition & Team Building",
        description:
            "At Mobikode, our people engineers, architects, and product teams bring real expertise in AI, cloud, data, and full-stack development, with a strong focus on collaboration and long-term partnerships.",
        image: "/assets/v/item12.png",
    },
    {
        id: 3,
        title: "Technology & Engineering Excellence",
        description:
            "At Mobikode, we build custom software, AI solutions, cloud systems, and mobile and web products tailored to your needs.",
        image: "/assets/v/item13.jpg",
    },
    {
        id: 4,
        title: "Managed Operations & Scaling",
        description:
            "Agile delivery, simple sprint management, clear performance tracking, and easy scaling as your needs change.",
        image: "/assets/v/item16.png",
    },
];

// --- DATA ---
const services = [
    {
        id: 1,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 2,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 3,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
    {
        id: 4,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 5,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 6,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
];

const toolsData = [
    {
        id: 1,
        title: "Cloud",
        desc: "AWS, Azure, Google Cloud",
    },
    {
        id: 2,
        title: "Data Platforms",
        desc: "Snowflake, BigQuery, Redshift, Synapse",
    },
    {
        id: 3,
        title: "BI & Visualization",
        desc: "Power BI, Tableau, Looker",
    },
    {
        id: 4,
        title: "AI & ML",
        desc: "Python, TensorFlow, PyTorch",
    },
    {
        id: 5,
        title: "Integration",
        desc: "Kafka, Airflow, dbt",
    },
];

const outcomesData = [
    {
        id: 1,
        text: "Faster, data-driven decision-making",
    },
    {
        id: 2,
        text: "Single source of truth across the enterprise",
    },
    {
        id: 3,
        text: "Predictive insights & automation",
    },
    {
        id: 4,
        text: "Improved efficiency, cost control & revenue growth",
    },
];

const whyMobikodePoints = [
    "Startups building and scaling engineering teams across global markets",
    "Mid-sized enterprises expanding and strengthening their digital capabilities",
    "Global companies setting up innovation hubs for faster product growth",
    "Organizations looking for cost-effective, strategic global delivery models",
];

const approachData = [
    {
        id: 1,
        step: "01",
        title: "Business-aligned approach",
        desc: "We build teams focused on results, not just numbers.",
    },
    {
        id: 2,
        step: "02",
        title: "Deep technology expertise",
        desc: "AI, cloud, and product engineering to help businesses grow smarter.",
    },
    {
        id: 3,
        step: "03",
        title: "Flexible engagement models",
        desc: "Start small, move step by step, and grow with confidence.",
    },
    {
        id: 4,
        step: "04",
        title: "India-based global delivery",
        desc: "Work with great talent worldwide and grow together smoothly.",
    },
    {
        id: 5,
        step: "05",
        title: "Long-term partnership mindset",
        desc: "We grow together with your success, every step of the way.",
    },
];

function GlobalCapability() {
    return (
        <div>
            <Helmet>
                <title>
                    Global Capability Center (GCC) Services | GCC Setup & Strategy | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode helps businesses establish and scale Global Capability Centers with GCC strategy, talent acquisition, technology engineering, managed operations, security, compliance, and global delivery expertise."
                />

                <meta
                    name="keywords"
                    content="Global Capability Center Services, GCC Services, GCC Setup Services, GCC Setup and Strategy, Global Capability Center Setup, GCC Consulting Services, GCC Strategy Consulting, GCC Talent Acquisition, GCC Team Building, GCC Technology Services, GCC Engineering Services, GCC Managed Services, GCC Operations, GCC Security and Compliance, GCC Governance, Global Delivery Center, India GCC Services, Offshore GCC Services, GCC Digital Transformation"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/global-capability-centers"
                />

                <meta
                    property="og:title"
                    content="Global Capability Center (GCC) Services | GCC Setup & Strategy | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Build and scale high-impact Global Capability Centers with Mobikode. From GCC strategy and talent building to engineering, managed operations, security, compliance, and global delivery."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/global-capability-centers"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/v/item17.jpg"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Global Capability Center (GCC) Services | GCC Setup & Strategy | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore Mobikode's GCC services for setup and strategy, talent acquisition, technology engineering, managed operations, security, compliance, and scalable global delivery."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/v/item17.jpg"
                />
            </Helmet>
            <AiHero title="Global Capability Center (GCC) Services" imgData="/assets/v/item17.jpg" />
            <section className="w-full py-[60px] lg:py-[100px] bg-white overflow-hidden font-sans">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="w-full bg-white border border-[#D5DDE8] flex flex-col lg:flex-row items-stretch">

                        <div className="w-full lg:w-full max-w-[498px] min-h-[260px] md:min-h-[350px] lg:min-h-[420px] overflow-hidden bg-gray-50">
                            <img
                                src="/assets/what/img4.png"
                                alt="ai automation"
                                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                            />
                        </div>

                        <div className="w-full lg:w-1/2 p-6 sm:p-10 lg:p-14 flex flex-col justify-center text-left">
                            <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-3">
                                Start with the right foundation
                            </p>
                            <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] leading-[1.25] tracking-tight mb-5">
                                Build, Scale, and Operate High-Impact Global Teams with Mobikode
                            </h2>
                            <p className="font-graphik text-[14px] lg:text-[16px] text-[#49577A] leading-[1.7] font-[500]">
                                At Mobikode, we support organizations in building and growing Global Capability Centers that truly feel like an extension of their team. It’s not just about saving costs, it's about creating value, driving innovation, and building strong, reliable teams that grow with your business goals.
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            <WhyAIAutomation heading="Our GCC Offerings" approachData={featuresData} />
            {/* <TechServicesSection title="Explore Our Services" sData={services} /> */}
            {/* <IndustriesWeServe /> */}
            <WhyChooseGCCSection approachData={approachData} />
            {/* <section className="w-full bg-[#FDFDFD] pb-16 lg:pb-24 relative overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                    <div className="mb-[30px] lg:mb-[60px]">
                        <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-left">
                            Why Choose Mobikode for Your GCC?
                        </h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                        {approachData.map((item) => (
                            <div
                                key={item.id}
                                className="relative bg-[#F0F0F0] p-8 min-h-[180px] flex flex-col justify-center overflow-hidden group transition-all duration-300 hover:shadow-lg hover:-translate-y-1 rounded-sm"
                            >
                                <div className="relative z-10">
                                    <h3 className="text-[#01386A] text-lg lg:text-[20px] font-[600] font-sora mb-2 leading-tight">
                                        {item.title}
                                    </h3>
                                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                                        {item.desc}
                                    </p>
                                </div>
                                <div
                                    className="absolute bottom-0 right-0 w-[180px] h-[140px] pointer-events-none transition-transform duration-500 group-hover:scale-110 opacity-50 lg:opacity-100"
                                >
                                    <img src="/assets/career/wrap1.svg" alt="" className="w-full h-full object-contain object-bottom-right" />
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section> */}

            <section className="w-full bg-white overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="w-full bg-white border border-[#D5DDE8] flex flex-col lg:flex-row items-stretch">
                        <div className="w-full lg:w-full max-w-[498px] overflow-hidden bg-gray-50">
                            <img
                                src="/assets/what/img6.png"
                                alt="Our GCC Services"
                                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                            />
                        </div>

                        {/* RIGHT CONTENT AREA */}
                        <div className="w-full lg:w-1/2 p-6 sm:p-10 lg:p-14 flex flex-col justify-center text-left">

                            {/* Top Sub-Badge */}
                            <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-2.5">
                                Ideal Fit & Scope
                            </p>

                            {/* Main Title */}
                            <h2 className="font-sora text-[20px]  lg:text-[30px] font-[600] text-[#01386A] leading-[1.25] tracking-tight mb-2">
                                Who is This For?
                            </h2>

                            {/* Sub-label */}
                            <p className="font-graphik text-[14px] sm:text-[16px] text-[#49577A] font-[500] mb-6">
                                Our GCC services are ideal for:
                            </p>

                            {/* Checkpoints List */}
                            <div className="flex flex-col gap-4">
                                {whyMobikodePoints.map((point, index) => (
                                    <div key={index} className="flex items-start gap-3.5 group">
                                        <div className="mt-0.5 shrink-0">
                                            <CheckCircle2 size={18} className="text-[#ED6800]" />
                                        </div>
                                        <p className="text-[#01386A] font-graphik text-[14px] lg:text-[16px] font-[500] leading-relaxed transition-colors duration-200 group-hover:text-[#ED6800]">
                                            {point}
                                        </p>
                                    </div>
                                ))}
                            </div>

                        </div>

                    </div>

                </div>
            </section>
            {/* <section className="relative w-full h-[400px] lg:h-[507px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/career/img12.png"
                        alt="Global Capability Center Background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] h-full flex items-center lg:items-center ">
                    <div className="bg-white p-8 lg:p-12 max-w-[620px] shadow-2xl rounded-sm">

                        <h2 className="text-[#01386A] text-[30px] lg:text-[40px] font-[600] font-sora leading-tight mb-6">
                            Global Capability Center (GCC) Services
                        </h2>
                        <p className="text-[#49577A] text-[16px] leading-[24px] font-graphik mb-8">
                       We create strategic hubs that bring together global talent to spark innovation, improve operations, and support digital growth helping businesses scale efficiently while staying flexible and cost-effective. </p>
                        <a href="/contact" className="inline-flex items-center gap-2 text-[#01386A] underline font-graphik font-semibold text-lg hover:gap-3 transition-all duration-300 group">
                            Contact Now
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
                        </a>

                    </div>
                </div>
            </section> */}
            <br/>
            <br/>
            <br/>
            <Banner title="Global Capability Center (GCC) Services" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
        <ContactSection/>
        </div>
    )
}

export default GlobalCapability
